import React from 'react';
import { FadeUp, CountUp } from '../../../components/shared/Motion';
import { EditableText, useEditMode } from '../../components';

function StatsCounter({ data, onChange }) {
  const { editMode } = useEditMode();
  const stats = data.stats || [];
  const updateStat = (i, patch) => {
    const next = stats.map((x, idx) => (idx === i ? { ...x, ...patch } : x));
    onChange && onChange({ ...data, stats: next });
  };
  return (
    <section className="relative py-20 bg-olive-deep text-white overflow-hidden">
      <div className="absolute inset-0 bg-grid-olive [background-size:42px_42px] opacity-30" />
      <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-accent/15 blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-olive-neon/15 blur-3xl" />
      <div className="container-page relative">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-10">
          {stats.map((s, i) => (
            <FadeUp key={i} delay={i * 0.1}>
              <div className={`relative text-center ${i > 0 ? 'lg:border-l lg:border-white/15' : ''} px-4`}>
                <div className="font-display font-extrabold text-accent text-5xl lg:text-6xl leading-none drop-shadow-[0_0_20px_rgba(197,120,99,0.45)]">
                  {editMode ? (
                    <span className="inline-flex items-center gap-1">
                      <EditableText
                        value={String(s.value ?? '')}
                        onChange={(t) => updateStat(i, { value: t })}
                        as="span"
                      />
                      <EditableText
                        value={s.suffix || ''}
                        onChange={(t) => updateStat(i, { suffix: t })}
                        as="span"
                      />
                    </span>
                  ) : (
                    <CountUp to={Number(s.value) || 0} suffix={s.suffix || ''} duration={1800 + i * 200} />
                  )}
                </div>
                <EditableText
                  value={s.label}
                  onChange={(t) => updateStat(i, { label: t })}
                  as="div"
                  className="mt-3 text-white/85 text-sm lg:text-base uppercase tracking-[0.18em] font-semibold"
                />
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}

export default StatsCounter;
